import COLORS from "lib/colors";
import { ENPS_QUALITY_RANGES } from "redux/pulse/constants";

export const FAVORABILITY_COLORS_NO_DATA: [string, string] = [
    COLORS["neutral-10"],
    COLORS["neutral-7"],
];

export const RESPONSIVENESS_COLORS_NO_DATA: [string, string] = [COLORS.white, COLORS["neutral-7"]];

const FAVORABILITY_COLORS: [number, number, string, string][] = [
    [0, 30, COLORS.red, COLORS.white],
    [30, 50, COLORS["red-orange"], COLORS.white],
    [50, 70, COLORS.yellow, COLORS["neutral-1"]],
    [70, 90, COLORS["medium-green"], COLORS.white],
    [90, 101, COLORS.green, COLORS.white],
];

const NO_VALUE_CLASS = "no-value";
const FAVORABILITY_VALUE_CLASSES: [number, number, string][] = [
    [0, 30, "very-negative"],
    [30, 50, "negative"],
    [50, 70, "medium"],
    [70, 90, "positive"],
    [90, 101, "very-positive"],
];

const RESPONSIVENESS_COLORS: [number, number, string, string][] = [
    [0, 15, COLORS["blue-10"], COLORS["blue-6"]],
    [15, 30, COLORS["blue-9"], COLORS["blue-4"]],
    [30, 40, COLORS["blue-7"], COLORS["blue-2"]],
    [40, 101, COLORS["blue-5"], COLORS.white],
];

const RESPONSIVENESS_VALUE_CLASSES: [number, number, string][] = [
    [0, 15, "very-weak"],
    [15, 30, "weak"],
    [30, 40, "strong"],
    [40, 101, "very-strong"],
];

const ENPS_COLORS: [number, number, string, string][] = ENPS_QUALITY_RANGES.map((eq) => [
    eq.range[0],
    eq.range[1],
    eq.color,
    eq.textColor,
]);

const ENPS_VALUE_CLASSES: [number, number, string][] = ENPS_QUALITY_RANGES.map((eq) => [
    eq.range[0],
    eq.range[1],
    eq.valueClass,
]);

export const getFavorabilityColor = (percent: number | null) => {
    if (percent == null) return FAVORABILITY_COLORS_NO_DATA;
    const color = FAVORABILITY_COLORS.find(
        ([minPerc, maxPerc]) => percent >= minPerc && percent < maxPerc,
    );
    return color ? [color[2], color[3]] : FAVORABILITY_COLORS_NO_DATA;
};

export const getFavorabilityValueClass = (percent: number | null) => {
    if (percent == null) return NO_VALUE_CLASS;
    const valueClass = FAVORABILITY_VALUE_CLASSES.find(
        ([minPerc, maxPerc]) => percent >= minPerc && percent < maxPerc,
    );
    return valueClass ? valueClass[2] : NO_VALUE_CLASS;
};

export const getFavorabilityBarChartColor = (percent: number | null) => {
    const color = getFavorabilityColor(percent);
    return color ? color[2] : FAVORABILITY_COLORS_NO_DATA[0];
};

export const getResponsivenessColor = (percent: number | null) => {
    if (percent == null) {
        return RESPONSIVENESS_COLORS_NO_DATA;
    }
    const color = RESPONSIVENESS_COLORS.find(
        ([minPerc, maxPerc]) => percent >= minPerc && percent < maxPerc,
    );
    return color ? [color[2], color[3]] : RESPONSIVENESS_COLORS_NO_DATA;
};

export const getResponsivenessValueClass = (percent: number | null) => {
    if (percent == null) return NO_VALUE_CLASS;
    const valueClass = RESPONSIVENESS_VALUE_CLASSES.find(
        ([minPerc, maxPerc]) => percent >= minPerc && percent < maxPerc,
    );
    return valueClass ? valueClass[2] : NO_VALUE_CLASS;
};

export const getEnpsColor = (score: number | null) => {
    if (score == null) return FAVORABILITY_COLORS_NO_DATA;
    const color = ENPS_COLORS.find(([minScore, maxScore]) => score >= minScore && score < maxScore);
    return color ? [color[2], color[3]] : FAVORABILITY_COLORS_NO_DATA;
};

export const getEnpsValueClass = (score: number | null) => {
    if (score == null) return NO_VALUE_CLASS;
    const valueClass = ENPS_VALUE_CLASSES.find(
        ([minScore, maxScore]) => score >= minScore && score < maxScore,
    );
    return valueClass ? valueClass[2] : NO_VALUE_CLASS;
};
